import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

/**
 * @name getListData
 * @description Get the list of data
 * @param {string} query
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const getListData = async (query) => {
    const response = await apiClient.request('GET', `/admin/facilities${query}`);
    if (!isApiResponseError(response)) {
        return response?.data;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};

/**
 * @name facilityDeleteByIds
 * @description Delete a facility by ids
 * @param {string} query
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const facilityDeleteByIds = async (ids) => {
    const response = await apiClient.request('DELETE', '/admin/facilities', ids);
    if (!isApiResponseError(response)) {
        return true;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};

/**
 * @name facilityGetDataWithId
 * @description Get a facility by ID
 * @param {string} facility_id
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const getDataWithId = async (facility_id) => {
    const response = await apiClient.request('GET', `/admin/facilities/${facility_id?.id}`);
    if (!isApiResponseError(response)) {
        return response?.data;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};

/**
 * @name facilityUpdateWithId
 * @description Update a facility by ID
 * @param {string} facility_id
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const facilityUpdateWithId = async (facility_id, data) => {
    const response = await apiClient.request('PUT', `/admin/facilities/${facility_id}`, data);
    if (!isApiResponseError(response)) {
        return response?.data;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};

/**
 * @name facilityCreate
 * @description Create a facility
 * @param {object} data
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const facilityCreate = async (data) => {
    const response = await apiClient.request('POST', '/admin/facilities', data);
    if (!isApiResponseError(response)) {
        return response?.data;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};

/**
 * @name facilityStatusUpdateWithId
 * @description Create a facility
 * @param {string} facility_id
 * @response success - 200 OK
 * @response failure - 404 Not Found
 * @returns {object} response.data
 */
export const facilityActiveWithId = async (facility_id) => {
    const response = await apiClient.request('PATCH', `/admin/facilities/${facility_id}/activate`);
    if (!isApiResponseError(response)) {
        return response?.data;
    } else {
        throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
    }
};


